<div *ngIf="show"
     class="alert alert-warning text-center mb-0"
     role="alert"
     style="position: sticky; top: 0; z-index: 1030; border-radius: 0; border-left: 0; border-right: 0; font-weight: 500;">
  Please update your password by the
  <a routerLink="/forgot_pwd"><strong>forgot password</strong></a>
  form due to changes in our rules.
</div>
